import { mergeSxProps } from "@clipboard-health/ui-components";
import { Stack, type StackProps } from "@mui/material";
import { type ForwardedRef, forwardRef } from "react";

interface DocumentPageScrollWrapperProps extends StackProps {
  children: React.ReactNode;
}

function BaseDocumentPageScrollWrapper(
  props: DocumentPageScrollWrapperProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const { sx, spacing = 7, ...restProps } = props;

  return (
    <Stack
      ref={ref}
      spacing={spacing}
      sx={mergeSxProps({ paddingX: 5, paddingBottom: 5, overflow: "auto" }, sx)}
      {...restProps}
    />
  );
}

export const DocumentPageScrollWrapper = forwardRef(BaseDocumentPageScrollWrapper);
